<div class="container-xl my-6">
  <a routerLink="/home" title="Go to the Help Center home page"
    ><i class="material-icons-round">chevron_left</i>Back to Help Center Home</a
  >
  <div class="row">
    <div class="col-md-9 mt-7">
      <div class="d-flex mb-6">
        <img
          [src]="categoryOne.categoryImg"
          alt="{{ categoryOne.categoryTitle }}"
          class="me-4"
        />
        <h2 class="flex-fill align-self-center text-dark my-0">
          {{ categoryOne.categoryTitle }}
        </h2>
      </div>
      <h3 class="mt-7 mb-5">Most Popular Questions</h3>
      <div class="row">
        <div
          class="col-md-6 mb-5"
          *ngFor="let featured of categoryOne.featuredFAQ"
        >
          <div class="lc-dt">
            <h5 class="mt-0" [innerHTML]="featured.question"></h5>
            <a [routerLink]="['/q-and-a/' + convertDotToSlash(featured.questionId)]">View answer</a>
          </div>
        </div>
      </div>
      <h3 class="mt-5 mb-5">Browse Questions</h3>
      <div *ngFor="let faq of categoryOne.subCategory">
        <h4 class="text-dark">{{ faq.title }}</h4>
        <p *ngFor="let faq of faq.QandA">
          <a
            [routerLink]="['/q-and-a/' + convertDotToSlash(faq.questionId)]"
            title="{{ faq.question }}"
            ><u class="text-dark" [innerHTML]="faq.question"></u
            ><i class="material-icons-round text-link">chevron_right</i></a
          >
        </p>
      </div>
      <h3 class="mt-7">Didn't find what you need?</h3>
      <p>
        <a
          href="{{isRegisteredUser ? 'https://www.labcorp.com/contact-us/labcorp-patient-portal' : 'https://www.labcorp.com/help/contact-info-for-patient/patient-portal-inquiry'}}"
          target="_blank"
          >Contact us for help</a
        >
      </p>
    </div>
    <div class="col-md-3 mt-7">
      <app-more-topics></app-more-topics>
    </div>
  </div>
</div>
